export default window.globals || { routes: {} }
